import { render, staticRenderFns } from "./YAN_QI_JIAO_FU.vue?vue&type=template&id=cdc86268"
import script from "./YAN_QI_JIAO_FU.vue?vue&type=script&lang=js"
export * from "./YAN_QI_JIAO_FU.vue?vue&type=script&lang=js"
import style0 from "./YAN_QI_JIAO_FU.vue?vue&type=style&index=0&id=cdc86268&prod&module=true&lang=less"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports